import { render, staticRenderFns } from "./CustomProstheticsCustomizationModal.vue?vue&type=template&id=01a30c1a&"
import script from "./CustomProstheticsCustomizationModal.vue?vue&type=script&lang=js&"
export * from "./CustomProstheticsCustomizationModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomProstheticsCustomizationModal.vue?vue&type=style&index=0&id=01a30c1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports